import Conmemoraciones from "../pages/Conmemoraciones";
import Home from "../pages/Home";
import SetsFunerarios from "../pages/Sets_funerarios";
import PlanesFuturos from "../pages/Planes_futuros";
import Seguimiento from "../pages/Seguimiento";
import Blog from "../pages/Blog";
import PreguntasFrecuentes from "../pages/PreguntasFrecuentes";

import AvisoPrivacidad from "../pages/AvisoPrivacidad";
import TerminosCondicioness from "../pages/TerminosCondiciones";
import SetFunerariosAgradecimientos from "../pages/SetFunerariosAgradecimientos";
import Ayuda from "../pages/Ayuda";






const routes = {
    Principales:
    [
        {id:1,show:true,name:'COLUMBA',path:'/',component:Home},
        {id:2,show:true,name:'SETS FUNERARIOS',path:'/SetsFunerarios',component:SetsFunerarios},
        {id:3,show:true,name:'PLANES A FUTURO',path:'/PlanesFuturo',component:PlanesFuturos},
        {id:4,show:true,name:'CONMEMORACIÓN',path:'/Conmemoraciones',component:Conmemoraciones},
        {id:5,show:true,name:'SEGUIMIENTO',path:'/Seguimiento',component:Seguimiento},
        {id:7,show:false,name:'PREGUNTAS FRECUENTES',path:'/PreguntasFrecuentes',component:PreguntasFrecuentes},
        {id:8,show:false,name:'AVISO DE PRIVACIDAD',path:'/AvisoPrivacidad',component:AvisoPrivacidad},
        {id:9,show:false,name:'TÉRMINOS Y CONDICIONES',path:'/TerminosCondiciones',component:TerminosCondicioness},
        {id:10,show:false,name:'SetFunerarios Agradecimientos',path:'/Sets-Gracias',component:SetFunerariosAgradecimientos},
        {id:11,show:false,name:'Ayuda',path:'/Ayuda',component:Ayuda},

    ],
    Secundarias:
    [
        {id:10,show:true,name:'CONMEMORACION DETALLE',path:'/Conmemoraciones/:id',component:Conmemoraciones},
        {id:11,show:true,name:'SETS FUNERARIOS COBERTURA',path:'/SetsFunerarios/Cobertura/:idcobertura',component:SetsFunerarios},
        {id:12,show:true,name:'SETS FUNERARIOS PERZONALIZA',path:'/SetsFunerarios/PersonalizaSet',component:SetsFunerarios},
        {id:13,show:true,name:'SETS FUNERARIOS DETALLLE',path:'/SetsFunerarios/:id',component:SetsFunerarios},
        {id:14,show:true,name:'SEGUIMIENTO DETALLE',path:'/Seguimiento/:folio/:appaterno',component:Seguimiento},
        {id:15,show:true,name:'BLOG',path:'/Blog/:id',component:Blog},

    ],
}


export default routes